import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import * as catalogo from '../catalogo';
import * as backInter from 'app/auth/auth-data.model';

@Component({
  selector: 'correos',
  templateUrl: './correos.component.html',
  styleUrls: ['./correos.component.scss'],
  animations   : fuseAnimations
})
export class CorreosComponent implements OnInit {

  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();
  @Output() enviaDatosEditor: EventEmitter<any> = new EventEmitter();
  comunicacionCorreos: any;
  @Input() entradaDatos: Observable<any>;


  // Datos certificar vigente
  productoActual: any;

  instituto: number;
  claveNativo: string;
  idEmpresa: string;
  idProducto: string;

  tiposCorreos:any[] = [
    {tipo: 1}, //invitacon
    {tipo: 2}, //recordatorio
    {tipo: 3},  //aviso 1
    {tipo: 4},  //aviso 2
    {tipo: 5},  //cierre
    {tipo: 6},  //personalizados aún no inician
    {tipo: 7},  //personalizados inican pero aún no acaban
  ];

  cargando = true;
  filtrado: boolean;
  sinCorreos = true;
  tipoCorreos:any;

  constructor(
    private programacionService: ProgramacionService,
    private wizardService: WizardService,
    private router: Router,
    private activatedRoute : ActivatedRoute,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.idEmpresa = params['id'];
      this.idProducto = params['idprod'];
    });
  }

  ngOnInit() {
    // this.obtieneProductoActual();
    this.comunicacionCorreos = this.entradaDatos.subscribe( (datos) => {
      console.log("se envio datos desde componente editor: ",datos);
      this.reiniciaVariables();
    });
    this.filtrado = false;
    this.getStatusTemplate();
    if (localStorage.getItem('tipoProct')=='Norma35') {
      this.tipoCorreos = catalogo.tipoCorreosNorma;

    }else{
    this.tipoCorreos = catalogo.tipoCorreos;
    }
  }

  irPaso(numPaso: number, tipoCorreo: number){
    this.cambiaPaso.emit(numPaso);
    this.enviaDatos(tipoCorreo);
  }
  regresarDetail(){
    this.router.navigate(['/companies/detail',this.idEmpresa]);
  }
  reiniciaVariables(){
    this.tipoCorreos.forEach(tipoCorreo => {
      tipoCorreo.activo = false;
    });
    this.cargando = true;
    this.filtrado = false;
    this.sinCorreos = true;
    this.getStatusTemplate();
  }

  getStatusTemplate(){
    console.log("Id ´producto "+this.idProducto);
    this.programacionService.statusTemplateODS(this.idEmpresa).subscribe((respuesta:any) => {
      console.log(respuesta);
      if (respuesta.message == "Success") {
        let  tiposCorreos_tmp:any[] = [];
        let correosFaltantes_tmp:any[]=[];
        correosFaltantes_tmp=respuesta.correosFaltantes;

        this.filtrado = true;
        this.tipoCorreos.forEach(tipoCorreo => {
          let idx = this.tiposCorreos.findIndex(item => item.tipo === tipoCorreo.tipoCorreo);
          if(idx != -1){
            let arrIdiomas:any[] = [];
            respuesta.correosFaltantes.forEach(correo => {
              let objIdioma:any = {};
              //console.log("Tipo correo "+tipoCorreo.tipoCorreo);
              //console.log("Correo tipo "+correo.tipo);
              //console.log("id producto "+correo.productoId);
              if(tipoCorreo.tipoCorreo == correo.tipo && this.idProducto == correo.productoId){
                objIdioma = correo;
                tipoCorreo.activo = true;
                this.sinCorreos = false;
                //console.log("entro");
              }
              if(objIdioma.tipo){
                arrIdiomas.push(objIdioma);
              }

            });
            this.tiposCorreos[idx].idiomas = arrIdiomas;
            console.log('this.tiposCorreos[idx].idiomas',arrIdiomas);
          }
        });
        this.cargando = false;

        /*correosFaltantes_tmp.forEach( correos =>{
          this.tipoCorreos.forEach(tipoCorreo => {
            if(tipoCorreo.tipoCorreo == correos.tipo && this.idProducto == correos.productoId){
              console.log("Si entro dude");
              //objIdioma = correo;
              //tipoCorreo.activo = true;
              //this.sinCorreos = false;
              //console.log("entro");
            }else{
              console.log("Pelucas");
            }
          });

        });*/
        // Prueba Temporal
        console.log("tiposcorreos:",this.tiposCorreos);
        console.log("tipocorreosCatalogo:",this.tipoCorreos);
        //console.log("Filtrado "+this.filtrado);
        //console.log("Sin correos "+this.sinCorreos);

      }
    });
  }

  enviaDatos(tipo:number){
    // let idProducto = 0;
    // let idPaquete = 0;
    // switch (localStorage.getItem('tipoProducto')) {
    //   case '1': case 'c1':
    //     idProducto = 1;
    //     idPaquete = 1
    //   break;
    // }
    // let datos: any = {
    //   tipo,                       //1=invitacion, 2=recordatorio
    //   idPaquete,                  //1 es certificar v1 y v2, 2 es nom good y better, 3 los medires, 4 pulse, 5 focus
    //   idProducto,                 //clave del producto, 1=certificar, 2=medirv1,... etc
    //   instituto: this.instituto,  //id instituto
    //   clave: this.claveNativo     //clave idioma
    // };
    let indice = this.tiposCorreos.findIndex(item => item.tipo == tipo);
    let datos: any = {
      tipo,
      idProducto: this.idProducto,
      idEmpresa: this.idEmpresa,
      tiposCorreos: this.tiposCorreos[indice]
    };
    this.enviaDatosEditor.emit(datos);
  }

}
